import { Stack, Typography, Box } from "@mui/material";
import { FC } from "react";
import { divider, text, blue, background } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { rounded } from "@/theme/variables";
import { TVocabularyWord } from "@/infrastructure/adapters/vocabulary";
import { IconCheckCircleFilled } from "@/assets/icons";
import { FormattedText } from "@/components/commons/FormattedText";
import { FileImage } from "@/components/commons/FileImage";

type TVocabularyWordCardProps = {
  word: TVocabularyWord;
  showFurigana?: boolean;
};

/** Word card: check icon left, text (furigana / kanji / translation) stacked right, optional tappable image below */
export const VocabularyWordCard: FC<TVocabularyWordCardProps> = ({ word, showFurigana = false }) => {
  const isMastered = word.status === "mastered";

  return (
    <Stack
      sx={{
        py: 1.5,
        px: 2,
        bgcolor: background.white,
        border: `1px solid ${divider.high}`,
        borderRadius: rounded.xs,
        flexShrink: 0,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="center" gap={1}>
        {/* Mastery icon */}
        <Box sx={{ display: "flex", fontSize: 24, color: isMastered ? blue[80] : background.disable }}>
          <IconCheckCircleFilled />
        </Box>

        {/* Text: furigana, kanji, translation */}
        <Stack gap={0.25} justifyContent="center" alignItems="center">
          {showFurigana && word.furigana && <Typography sx={{ ...typography.body14Semi, color: blue[80] }}>{word.furigana}</Typography>}
          <Typography sx={{ ...typography.sub16Bold, color: text.primary }}>{word.kanji}</Typography>
          <Typography sx={{ ...typography.body14Semi, color: text.secondary }}>
            <FormattedText text={word.translation} />
          </Typography>
        </Stack>
      </Stack>

      {word.imageFile && <FileImage filePath={word.imageFile} />}
    </Stack>
  );
};
